/* eslint-disable react/prop-types */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import find from "lodash/find";

import * as modalActions from "../../../actions/modalActions";
import * as callActions from "../../../actions/callActions";
import * as codeActions from "../../../actions/codeActions";

import CallPartsList from "./CallPartsList";
import CallPartsForm from "./CallPartsForm";
import HeaderWrapper from "../../common/HeaderWrapper";
import Modal from "../../common/Modal";
import ConfirmModal from "../../common/ConfirmModal";

class CallPartsPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { adding: false, part: {} };
  }

  componentDidMount = () => {
    this.props.actions.getCall(this.props.match.params.id);
  };

  onClickAdd = () => {
    this.setState({ part: {}, adding: true });
    this.props.actions.getCall(this.props.call._id, true);
  };

  onClickEdit = (part) => {
    const { call } = this.props;
    // eslint-disable-next-line no-param-reassign
    part = find(call.parts, { id: part });
    this.setState({ adding: false, part });
    this.props.actions.getCall(call._id, true);
  };

  onClickDelete = (partId) => {
    this.props.actions.requestPartId(partId);
  };

  handleDelete = async () => {
    await this.props.actions.deletePart(
      this.props.call._id,
      this.props.partToDelete
    );
    await this.props.actions.getCall(this.props.call._id);
  };

  handleAdd = async (part) => {
    await this.props.actions.createPart(this.props.call._id, part);
    await this.props.actions.hideModal();
    await this.props.actions.getCall(this.props.call._id);
  };

  handleSave = async (part) => {
    part.id = this.state.part.id;

    await this.props.actions.updatePart(this.props.call._id, part);
    await this.props.actions.hideModal();
    await this.props.actions.getCall(this.props.call._id);
  };

  handleCancel = () => {
    this.props.actions.hideModal();
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  render() {
    const { call, codes, savingCall, isMobile } = this.props;
    const { part, adding } = this.state;

    const partsForm = (
      <CallPartsForm
        part={part || {}}
        codes={codes}
        onAdd={this.handleAdd}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        saving={savingCall}
        adding={this.state.adding}
      />
    );

    return (
      <>
        <HeaderWrapper
          breadcrumbs={[{ label: "Edit Call" }, { label: "Parts" }]}
          onClickAdd={this.onClickAdd}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <CallPartsList
            call={call}
            isMobile={isMobile}
            onClickEdit={this.onClickEdit}
            onClickDelete={this.onClickDelete}
          />
        </div>
        <Modal
          id="callDetailsModal"
          title={adding ? "Add Part" : "Edit Call"}
          body={partsForm}
          close={this.props.actions.hideModal}
        />
        <ConfirmModal
          id="partDeleteModal"
          title="Delete Part"
          body="Are you sure you want to delete this part?"
          close={this.props.actions.hideModal}
          confirm={this.handleDelete}
        />
      </>
    );
  }
}

CallPartsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  codes: PropTypes.array.isRequired,
  savingCall: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    partToDelete: state.reducers.partToDelete,
    savingCall: state.reducers.savingCall,
    call: state.reducers.call,
    codes: state.reducers.codes
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...callActions,
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(CallPartsPage);
